export const url = "https://boibazaar.viserx.net";
export const local = "https://boibazaar.viserx.net";
// export const url = "http://boibazar.test";
// export const local = "http://boibazar.test";
// export const url = "http://boibazar-frontend.topratedseo.website";
// export const local = "http://boibazar-frontend.topratedseo.website";
